import { css } from '@emotion/react';
import { cn } from '@anytag/shared-utils';
import { THEME } from '@anytag/shared-constants';
import { manageLocalStorage } from '@anytag/router';
import { mailOpenedImage } from '@anytag/shared-assets';
import { SignInSignUpLayout } from '@anytag/shared-organisms';
import { useResendEmailForAdvertiserMutation } from '@anytag/graphql';
import { Anchor, ButtonLink, RenderDataWithFallback } from '@anytag/shared-atoms';
import { useQueryHelper, useToggleState, useUpdateDocumentTitle } from '@anytag/shared-hooks';

export const SignUpSuccess = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.SignUp' });
  const { t, enqueueSnackbar } = useQueryHelper();
  const { status: loading, setStatus: setLoading } = useToggleState(false);
  const { callResendEmailForAdvertiser } = useResendEmailForAdvertiserMutation();

  const email = manageLocalStorage('get', 'confirmationEmail') || '';

  const handleResendEmail = async () => {
    setLoading(true);
    try {
      await callResendEmailForAdvertiser({ variables: { input: { email } } });
      enqueueSnackbar('Confirmation email has been resended', { variant: 'success' });
      manageLocalStorage('remove', 'confirmationEmail');
    } catch (error) {
      enqueueSnackbar('Failed to resend email, please try again', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SignInSignUpLayout headerProps={{ to: '/sign-in' }} footerProps={{ hasCopyRight: true }}>
      <RenderDataWithFallback loading={loading} loadingProps={{ className: cn('h-92.5') }}>
        <div css={{ textAlign: 'center', padding: '48px 24px' }}>
          <img width="48px" height="48px" css={{ margin: '0 auto' }} src={mailOpenedImage} alt="opened mail" />

          <p css={{ fontSize: '20px', marginTop: '24px', lineHeight: '100%', letterSpacing: 'normal' }}>
            {t('We have sent a confirmation email')}
          </p>

          {email ? <p css={styles.email}>{email}</p> : null}

          <p css={{ marginTop: '40px', fontSize: '14px', lineHeight: '160%' }}>
            {t('SignUp.Confirmation_1')}
            <br />
            {t('SignUp.Confirmation_2')}
          </p>

          <Anchor css={styles.link} variant="blue" onClick={handleResendEmail}>
            {t('Resend confirmation email')}
          </Anchor>

          <ButtonLink to="/" title={t('Button.Back')} className="mx-auto mt-6 mb-0" />
        </div>
      </RenderDataWithFallback>
    </SignInSignUpLayout>
  );
};
const styles = {
  email: css({
    display: 'block',
    fontSize: '14px',
    lineHeight: '160%',
    padding: '4px 8px',
    fontStyle: 'normal',
    width: 'max-content',
    margin: '16px auto 0',
    fontStretch: 'normal',
    boxSizing: 'border-box',
    letterSpacing: 'normal',
    backgroundColor: THEME.background.colors.gray.lv1
  }),
  link: css({
    justifySelf: 'center',
    fontSize: '12px',
    marginTop: '24px',
    lineHeight: '15px',
    letterSpacing: '0.5px',
    '&:hover': { opacity: 0.8, textDecoration: 'none' }
  })
};
